import React, { useEffect } from "react";
import { useForm } from "react-hook-form";

import { P } from "../../atoms/Texts";
import { DarkFormField, DarkTextArea } from "../../atoms/Inputs";
import { NewProgramFooter } from "../../organisms/Footers/footer.new.program";

const AddProgramFormOne = ({
  changeStep,
  discard,
  fields,
  updateFields,
  saveToDraft,
}) => {
  const {
    register,
    formState: { errors },
    handleSubmit,
    getValues,
  } = useForm();

  const updateData = (data) => {
    updateFields(data);
    changeStep(2);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <main className="">
      <form onSubmit={handleSubmit(updateData)}>
        <section className="pb-10 lg:w-10/12 grid grid-cols-1 lg:grid-cols-2 gap-4 organization-container">
          {/* Name */}
          <div>
            <DarkFormField
              type="text"
              id="name"
              name="name"
              placeholder="Enter service name"
              label="Service Name"
              containerClass="flex-grow"
              defaultValue={fields.name || ""}
              {...register("name", {})}
              required
            />
            {errors.name && (
              <P fontSize="12px" className="-mt-4 mb-4 text-red-400 text-sm">
                {errors.name.message}
              </P>
            )}
          </div>

          {/* Status */}
          <div>
            <DarkFormField
              type="text"
              id="status"
              name="status"
              placeholder="Enter service status"
              label="Service Status"
              containerClass="flex-grow"
              defaultValue={fields.status || ""}
              {...register("status")}
            />
          </div>

          {/* Alternate Name */}
          <div>
            <DarkFormField
              type="text"
              id="alternateName"
              name="alternateName"
              placeholder="E.g Social Safety Corps"
              label="What Other Name is your Organization known as? "
              containerClass="flex-grow"
              defaultValue={fields.alternateName || ""}
              {...register("alternateName")}
            />
          </div>

          {/* Website */}
          <div>
            <DarkFormField
              type="url"
              id="url"
              name="url"
              placeholder="e.g https://example.com"
              label="Website"
              containerClass="flex-grow"
              defaultValue={fields.url || ""}
              {...register("url", {
                pattern: {
                  value:
                    /^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/,
                  message: "Please enter a valid link.",
                },
              })}
            />

            {errors.url && (
              <P fontSize="12px" className="-mt-4 mb-4 text-red-400 text-sm">
                {errors.url.message}
              </P>
            )}
          </div>

          {/* Description */}
          <div className="lg:col-span-2">
            <DarkTextArea
              rows={3}
              id="description"
              name="description"
              placeholder="Describe the service, this helps explain what the service is about..."
              label="Description"
              className="w-full"
              defaultValue={fields.description || ""}
              required
              {...register("description", {})}
            />

            {errors.description && (
              <P fontSize="12px" className="-mt-4 mb-4 text-red-400 text-sm">
                {errors.description.message}
              </P>
            )}
          </div>

          {/* Interpretation Service */}
          <div className="lg:col-span-2">
            <DarkTextArea
              rows={3}
              id="interpretationServices"
              name="interpretationServices"
              placeholder="What languages do you interpret?"
              label="Interpretation Service"
              containerClass="flex-grow"
              required
              defaultValue={fields.interpretationServices || ""}
              {...register("interpretationServices", {
                minLength: {
                  value: 2,
                  message: "Please enter a valid interpretation service.",
                },
              })}
            />

            {errors.interpretationServices && (
              <P fontSize="12px" className="-mt-4 mb-4 text-red-400 text-sm">
                {errors.interpretationServices.message}
              </P>
            )}
          </div>

          {/* Application Process */}
          <div className="lg:col-span-2">
            <DarkTextArea
              rows={3}
              id="applicationProcess"
              name="applicationProcess"
              placeholder="Explain the application stages..."
              label="Application Process"
              containerClass="flex-grow"
              defaultValue={fields.applicationProcess || ""}
              required
              {...register("applicationProcess", {
                minLength: {
                  value: 2,
                  message: "Please enter service application process.",
                },
              })}
            />

            {errors.applicationProcess && (
              <P fontSize="12px" className="-mt-4 mb-4 text-red-400 text-sm">
                {errors.applicationProcess.message}
              </P>
            )}
          </div>

          {/* Email */}
          <div className="lg:col-span-2">
            <DarkFormField
              type="email"
              id="email"
              name="email"
              placeholder="example@mail.com"
              label="Email"
              containerClass="flex-grow"
              required
              defaultValue={fields.email || ""}
              {...register("email", {
                pattern: {
                  value:
                    /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
                  message: "Please enter a valid email.",
                },
              })}
            />

            {errors.email && (
              <P fontSize="12px" className="-mt-4 mb-4 text-red-400 text-sm">
                {errors.email.message}
              </P>
            )}
          </div>

          {/* Cost */}
          <div className="lg:col-span-2">
            <DarkFormField
              type="text"
              id="cost"
              name="cost"
              placeholder="e.g USD 500.12"
              label="Cost"
              containerClass="flex-grow"
              defaultValue={fields.cost || ""}
              {...register("cost")}
            />
          </div>

          {/* Wait time */}
          <div className="lg:col-span-2">
            <DarkFormField
              type="text"
              id="waitTime"
              name="waitTime"
              placeholder="e.g 1 day"
              label="Wait Time"
              containerClass="flex-grow"
              defaultValue={fields.waitTime || ""}
              required
              {...register("waitTime", {
                minLength: {
                  value: 2,
                  message: "Please enter service wait time.",
                },
              })}
            />

            {errors.waitTime && (
              <P fontSize="12px" className="-mt-4 mb-4 text-red-400 text-sm">
                {errors.waitTime.message}
              </P>
            )}
          </div>

          {/* Currently Serving */}
          <div className="lg:col-span-2">
            <DarkFormField
              type="number"
              id="currentlyServing"
              name="currentlyServing"
              placeholder="e.g 2"
              label="Currently Serving"
              containerClass="flex-grow"
              defaultValue={fields.currentlyServing || ""}
              {...register("currentlyServing")}
            />
          </div>

          {/* Overall Capacity */}
          <div className="lg:col-span-2">
            <DarkFormField
              type="number"
              id="overallCapacity"
              name="overallCapacity"
              placeholder="E.g 1"
              label="Overall Capacity"
              containerClass="flex-grow"
              defaultValue={fields.overallCapacity || ""}
              {...register("overallCapacity")}
            />
          </div>
        </section>

        <NewProgramFooter
          changeStep={updateFields}
          updateFields={updateFields}
          discard={discard}
          saveToDraft={() => {
            const values = getValues();
            saveToDraft(values);
          }}
        />
      </form>
    </main>
  );
};

export default AddProgramFormOne;
